import { render, staticRenderFns } from "./userQuestion.vue?vue&type=template&id=44ced08a&scoped=true&"
import script from "./userQuestion.vue?vue&type=script&lang=js&"
export * from "./userQuestion.vue?vue&type=script&lang=js&"
import style0 from "./userQuestion.vue?vue&type=style&index=0&id=44ced08a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ced08a",
  null
  
)

export default component.exports